// extracted by mini-css-extract-plugin
export default {"container":"TrapImagesComponent_container__8fjwR","card":"TrapImagesComponent_card__pgjtI"};